import React from 'react';
import { View, Image as RNImage, ImageBackground } from 'react-native';
import { isRowLayout } from '../../utilities/screen';
import Section from '../sections/Section';
import { SHADOWS } from '../../settings/shadows';
import { BEIGE } from '../../settings/colors';

function TiltedImageLayout(props) {
  const [isPortrait, setAspectRatio] = React.useState(undefined);
  const [imageSize, setImageSize] = React.useState({});
  React.useEffect(() => {
    const image = new Image();
    image.src = props.image;
    const { height, width } = image;
    setAspectRatio(height > width);
    setImageSize({ height, width });
  }, []);
  return (
    <Section
      backgroundColor={props.backgroundColor || 'white'}
      style={{
        flexDirection: isRowLayout
          ? props.reverse
            ? 'row-reverse'
            : 'row'
          : 'column-reverse',
        maxWidth: 1200,
        alignItems: 'center',
      }}
    >
      <View
        style={{
          alignItems: 'flex-start',
          alignSelf: 'center',
          flex: 1,
          flexBasis: 'auto',
          maxWidth: 400,
        }}
      >
        {props.children}
      </View>
      <View
        style={{
          flex: 1,
          height: '70vh',
          width: '100%',
          flexBasis: isRowLayout ? '50%' : 'auto',
          paddingHorizontal: isRowLayout ? 30 : props.tilt ? 30 : 0,
          paddingVertical: isRowLayout ? 0 : 30,
          overflow: 'visible',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <RNImage
          source={props.image}
          style={[
            {
              height: '100%',
              width: '100%',
              overflow: 'visible',
            },
            // ? Maybe fix performance issue?
            // props.tilt && {
            //   transform: [{ rotate: props.reverse ? '-5deg' : '5deg' }],
            // },
            props.shadow && SHADOWS.bigShadow,
          ]}
          resizeMode="contain"
        />
      </View>
    </Section>
  );
}

export default TiltedImageLayout;
